export const getAppScalingFactor = (): number => {
  return window ? window.innerWidth / 1920 : 1;
};
